import { CONFIG_NO_ERROR_TOAST, DURATION_10_MIN } from '@src/constants';
import {
  getBusinessCountriesService,
  getBusinessIndustriesService,
  getBusinessTypesByCountryService,
  getBusinessTypesService,
  getSettlementPaymentTypesByCountryService,
  getStatesByCountryService,
  getTransferTypesService
} from '@src/services/application-service';
import ClientApi from '@src/types/client';
import { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';

export const useGetBusinessCountries = (
  payload: ClientApi.Application.GetBusinessCountries.Request,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options?: UseQueryOptions<ClientApi.General.BusinessCountryI[], AxiosError<any>>
) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return useQuery<ClientApi.General.BusinessCountryI[], AxiosError<any>>({
    queryKey: ['getBusinessCountries', payload.BusinessCountry],
    queryFn: () => getBusinessCountriesService(payload, CONFIG_NO_ERROR_TOAST),
    staleTime: DURATION_10_MIN,
    ...options
  });
};

export const useGetStatesByCountry = (
  payload: ClientApi.Application.GetStatesByCountry.Request,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options?: UseQueryOptions<ClientApi.General.StateI[], AxiosError<any>>
) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return useQuery<ClientApi.General.StateI[], AxiosError<any>>({
    queryKey: ['getStatesByCountry', payload.countryCode],
    queryFn: () => getStatesByCountryService(payload, CONFIG_NO_ERROR_TOAST),
    staleTime: DURATION_10_MIN,
    ...options
  });
};

export const useGetBusinessTypes = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options?: UseQueryOptions<ClientApi.General.BusinessTypeI[], AxiosError<any>>
) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return useQuery<ClientApi.General.BusinessTypeI[], AxiosError<any>>({
    queryKey: ['getBusinessTypes'],
    queryFn: () => getBusinessTypesService(CONFIG_NO_ERROR_TOAST),
    staleTime: DURATION_10_MIN,
    ...options
  });
};

export const useGetBusinessTypesByCountry = (
  payload: ClientApi.Application.GetBusinessTypesByCountry.Request,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options?: UseQueryOptions<ClientApi.General.BusinessTypeI[], AxiosError<any>>
) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return useQuery<ClientApi.General.BusinessTypeI[], AxiosError<any>>({
    queryKey: ['getBusinessTypesByCountry'],
    queryFn: () => getBusinessTypesByCountryService(payload, CONFIG_NO_ERROR_TOAST),
    staleTime: DURATION_10_MIN,
    ...options
  });
};

export const useGetBusinessIndustries = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options?: UseQueryOptions<ClientApi.General.BusinessIndustryI[], AxiosError<any>>
) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return useQuery<ClientApi.General.BusinessIndustryI[], AxiosError<any>>({
    queryKey: ['getBusinessIndustries'],
    queryFn: () => getBusinessIndustriesService(CONFIG_NO_ERROR_TOAST),
    staleTime: DURATION_10_MIN,
    ...options
  });
};

export const useGetTransferTypes = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options?: UseQueryOptions<ClientApi.General.TransferTypesI[], AxiosError<any>>
) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return useQuery<ClientApi.General.TransferTypesI[], AxiosError<any>>({
    queryKey: ['getTransferTypes'],
    queryFn: () => getTransferTypesService(CONFIG_NO_ERROR_TOAST),
    staleTime: DURATION_10_MIN,
    ...options
  });
};

export const useGetSettlementPaymentTypesByCountry = (
  payload: ClientApi.Application.GetSettlementPaymentTypesByCountry.Request,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options?: UseQueryOptions<ClientApi.General.PaymentTypeInfo[], AxiosError<any>>
) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return useQuery<ClientApi.General.PaymentTypeInfo[], AxiosError<any>>({
    queryKey: ['getSettlementPaymentTypesByCountry', payload.CountryCode],
    queryFn: () => getSettlementPaymentTypesByCountryService(payload, CONFIG_NO_ERROR_TOAST),
    staleTime: DURATION_10_MIN,
    ...options
  });
};
